import React, {useEffect, useState} from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { obtenerDatosHotel } from '../../services/motorService';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
// Necesario para corregir el problema con los iconos de Leaflet
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

export default function MapComponent() {
  
  const [datosHotel, setDatosHotel] = useState({});
  const hotCod = Cookies.get('hotCod');
  
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod);
        setDatosHotel(data);
      } catch (error) {
        console.error('Error fetching hotel data:', error);
      }
    };
    getData();
  }, []);

  const latitud = parseFloat(datosHotel?.MotorHotLatitud?.trim());
  const longitud = parseFloat(datosHotel?.MotorHotLogitud?.trim());
  
  if (!latitud || !longitud) {
    console.log("Latitud o longitud no disponibles");
    return <p>Cargando mapa...</p>;
  }
  
  const position = [latitud, longitud];

  return (
    <MapContainer center={position} zoom={13} style={{ height: "400px", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={position}>
        <Popup>
          Aquí están las coordenadas: <br /> {position[0]}, {position[1]}.
        </Popup>
      </Marker>
    </MapContainer>
  );
}